import ReactDOM from 'react-dom/client';
import App from './App';
import Layout from './pages/layout';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Layout>
    <App />
  </Layout>
);
